import { Flex } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { useSetRecoilState } from "recoil";
import { FieldType } from "../../../entities/TicketField";
import { useShopAgents } from "../../../hooks/agentHooks";
import { useTicketFieldsForView } from "../../../hooks/ticketFieldHooks";
import { toDate } from "../../../lib/datetime";
import ticketListState from "../../../state/ticketListState";
import useAuthContext from "../../context/AuthContext";
import CustomTicketListRow from "../../molecules/table/CustomTicketListRow";
import TicketListFunctions from "../../molecules/table/TicketListFunctions";

const CustomTicketList = ({ currentTickets, unit }) => {

  const {currentShop} = useAuthContext()
  const setTicketListState = useSetRecoilState(ticketListState)
  const ticketFields = useTicketFieldsForView()
  const agents = useShopAgents(currentShop?.id)
  const [sorted, setSorted] = useState([])
  const [sortFieldDirections, setSortFieldDirections] = useState({})
  useEffect(() => {
    if(!unit) return;
    const tmp = {}
    unit.visibleFieldCodes.forEach((code => {
      tmp[code] = 1
    }))
    setSortFieldDirections(tmp)
  }, [unit]);

  useEffect(() => {
    setSorted(currentTickets)
  }, [currentTickets]);

  const onClick = (code, field) => {
    if (["Checkbox", "Textarea"].includes(field?.type)) return

    const sortField = ticketFields.find((field) => field.code == code)
    setSortFieldDirections({
      ...sortFieldDirections,
      [sortField.code]: sortFieldDirections[sortField.code] * -1
    })
    const direction = sortFieldDirections[sortField.code]
    if (["Date", "Datetime", "Time"].includes(sortField?.type)) {
      setTicketListState((ticketList) => {
        let tmp = [...ticketList]
        tmp.sort((a,b) => {
          return (toDate(a[sortField.code]) - toDate(b[sortField.code])) * direction
        })
        return tmp
      })
    } else if (["String", "Number", "SingleSelect", "Radio",
                "Category_1", "Category_2", "Category_3", "Reason_1", "Reason_2", "Reason_3"].includes(sortField?.type)) {
      setTicketListState((ticketList) => {
        let tmp = [...ticketList]
        tmp.sort((a,b) => {
          const codeA = a[sortField.code]?.toUpperCase()
          const codeB = b[sortField.code]?.toUpperCase()
          if ((codeA || '') < (codeB || '')) {
            return -1 * direction
          }
          if ((codeA || '') > (codeB || '')) {
            return 1 * direction
          }
        })
        return tmp
      })
    } else if (sortField?.type == FieldType.Boolean) {
      setTicketListState((ticketList) => {
        let tmp = [...ticketList]
        tmp.sort((a,b) => ((a[sortField.code]?.length || 0) - (b[sortField.code]?.length || 0)) * direction)
        return tmp
      })
    } else if (sortField?.type == FieldType.Agent) {
      setTicketListState((ticketList) => {
        let tmp = [...ticketList]
        tmp.sort((a,b) => {
          const agentA = agents?.find((agent) => agent.id == a)
          const agentB = agents?.find((agent) => agent.id == b)
          if (!agentA || !agentB) {
            return 0
          }
          if ((agentA.name || agentA.email) < (agentB.name || agentB.email)) {
            return -1 * direction
          }
          if ((agentA.name || agentA.email) > (agentB.name || agentB.email)) {
            return 1 * direction
          }
        })
        return tmp
      })
    }
  }

  return (<>
    <TicketListFunctions />
    <table className={`table-fixed w-full bg-white rounded-t-md`}>
      <thead className="h-20 text-lg rounded-t-md">
        <tr className="rounded-t-md">
          <th className="w-14"></th>
          { unit?.visibleFieldCodes?.map((code) => {
            const field = ticketFields.find((field) => field.code == code);
            return (<th key={code} className={`${!["Checkbox", "Textarea"].includes(field?.type) ? 'cursor-pointer' : ''}`} onClick={() => onClick(code, field)}>
              <Flex>
                {field?.name}
                { !["Checkbox", "Textarea"].includes(field?.type) && sortFieldDirections[field?.code] > 0 &&
                  <IoMdArrowDropdown
                    fontSize="inherit"
                    style={{ fontSize: "2.25rem", lineHeight: "5rem", color: "#707C97" }}
                  />
                }
                { !["Checkbox", "Textarea"].includes(field?.type) && sortFieldDirections[field?.code] < 0 &&
                  <IoMdArrowDropup
                    fontSize="inherit"
                    style={{ fontSize: "2.25rem", lineHeight: "5rem", color: "#707C97" }}
                  />
                }
              </Flex>
            </th>)
          })}
        </tr>
      </thead>
      <tbody className="p-10 bg-white last:rounded-b-md box-border">
        { sorted && sorted.map((ticket) => {
          return <CustomTicketListRow key={ticket.id} ticket={ticket} unit={unit} ticketFields={ticketFields} />
        })}
      </tbody>
    </table>
  </>)
}

export default CustomTicketList;